import React from 'react'
import '../styles/about.css'

function About() {
    return(
        <div className="about_wrapper page_content">
            <section>
            <h3>Our Vision & Mission</h3>
            <p>
            To build trusted long-term relationships with private businesses, government, municipalities,
            and non-profit organisations by providing quality information technology (IT) products,
            services and solutions, in the promise of excellent client experience.
            </p>

            <p className="vision">
                <h3>Our Values</h3>
                <ul>
                    <li> Trust and Mutual Respect</li>
                    <li> Transparency and honesty</li>
                    <li> Participation and Empowerment</li>
                    <li> Professionalism and Integrity</li>
                    <li> Quality and Service Excellence</li>
                </ul>
            </p>
            </section>
            
            <section>
                <h3>Business Model</h3>
                <p>Smart KS’s business model is driven by our consultative approach allowing us to
                build and maintain solid business relationships with our valued clients. This gives
                us latitude to explore more than just the stipulated mandate but additional value
                streams that will enhance our clients competitive position or service delivery
                position.</p>

                <p>Our strategic sources prowess permits us to source quality IT products through
                elaborate supply chain network and passed on to our clients.</p>

                <p>
                We employ the best in the field, engineers and technicians to effectively manage
                and support our clients with minimum downtime thus promoting enhanced
                productivity.
                </p>
            </section>

            <section>
                <h3>Commitments</h3>
                <p>Our commitment to our customer and stakeholders is to be the best and most
                    successful ICT partner in our region.</p>

                    <p>We believe that our transformation lies in partnering with vendors listed below
                    and not limited to:</p>

                    <ul>
                        <li>Hewlett-Packard</li>
                        <li> Cisco</li>
                        <li> Microsoft</li>
                        <li> Dell</li>
                        <li> Aruba</li>
                        <li> Symantec</li>
                        <li> Trend Micro</li>
                        <li> Amazonweb services</li>
                        <li> Veem Cloud</li>
                        <li> VMWare</li>
                        <li> Huawei</li>
                    </ul>
            </section>
        </div>
    )
}

export default About;